class RoNavigationSelect extends HTMLElement {
  constructor() {
    super();
  }

  /* STATES */
  get open() {
    return this.hasAttribute('open');
  }

  set open(flag) {
    if (flag) {
      this.setAttribute('open', true);
      this.documentClickListenerAbortController = new AbortController();

      document.addEventListener(
        'click',
        (event) => this.handleOutsideClick(event),
        {
          'signal': this.documentClickListenerAbortController.signal
        }
      );
    } else {
      this.removeAttribute('open');
      this.documentClickListenerAbortController.abort();
    }
  }

  toggleOpen() {
    this.open ? this.open = false : this.open = true;
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      this.toggleOpen();
    });
  }

  handleOutsideClick(event) {
    if (! this.contains(event.target) && this.open === true) {
      this.toggleOpen();
    }
  }
}

customElements.define('ro-navigation-select', RoNavigationSelect);